import type { GroceryItem } from "./domain";
import type { NeedEntry } from "./need-store";

export interface ShopEntry extends NeedEntry {
  item: GroceryItem;
  unassigned: boolean;
  assignedToSelectedStore: boolean;
  bestPriceWarning: string | null;
}

export function shopEntries(need: NeedEntry[], items: GroceryItem[], storeId: number): ShopEntry[] {
  const byId = new Map(items.map(item => [item.id, item]));
  return need.flatMap(entry => {
    const item = byId.get(entry.itemId);
    if (!item) return [];
    const unassigned = item.stores.length === 0;
    const assignedToSelectedStore = item.stores.some(store => store.storeId === storeId);
    if (!unassigned && !assignedToSelectedStore) return [];
    const bestPriceWarning = assignedToSelectedStore && item.bestPriceStore && item.bestPriceStore.storeId !== storeId
      ? `Best price at ${item.bestPriceStore.storeName}`
      : null;
    return [{ ...entry, item, unassigned, assignedToSelectedStore, bestPriceWarning }];
  });
}

export function mergeVisibleOrder(all: NeedEntry[], reorderedVisibleIds: number[]): number[] {
  const visible = new Set(reorderedVisibleIds);
  let index = 0;
  return all.map(entry => visible.has(entry.id) ? reorderedVisibleIds[index++]! : entry.id);
}
